import React, { useEffect, useState } from "react";
import { useProfile } from '../ProfileContext';


function FilmList() {
    const { selectedProfileId } = useProfile();
    const [films, setFilms] = useState([]);
    const [showMedias, setShowMedias] = useState(false);

    const [favs, setFavs] = useState([]);

    useEffect(() => {
        fetch(`/fav/list-favs/${selectedProfileId}`)
            .then((response) => response.json())
            .then((data) => {
                // Shuffle the array randomly
                const shuffledFilms = [...data].sort(() => Math.random() - 0.5);
                setFavs(shuffledFilms);
                // Show the films with a delay of 200ms between each film after 2 seconds
                setTimeout(() => {
                    setShowMedias(true);
                }, 800);
            })
            .catch((error) => console.error("Server error"));
    }, []);

    useEffect(() => {
        fetch(`/fav/list-favs/${selectedProfileId}`)
            .then((response) => response.json())
            .then((data) => {
                // Shuffle the array randomly
                const shuffledFilms = [...data].sort(() => Math.random() - 0.5);
                setFilms(shuffledFilms);
                // Show the films with a delay of 200ms between each film after 2 seconds
                setTimeout(() => {
                    setShowMedias(true);
                }, 800);
            })
            .catch((error) => console.error("Server error"));
    }, []);

    const handleHeartClickAdd = async (event) => {
        try {
            const mediaId = event.currentTarget.getAttribute('data-media-id');

            const response = await fetch('/fav/add-media-perso', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ selectedProfileId, mediaId }),
            });

            if (response.ok) {
                // Handle success, e.g., show a success message
                console.log('Media added to the list successfully');
                const updatedFavs = [...favs, { _id: mediaId }];
                setFavs(updatedFavs);
            } else {
                // Handle error, e.g., show an error message
                console.error('Failed to add media to the list');
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const handleHeartClickRemove = async (event, filmId) => {
        event.stopPropagation(); // Empêcher la propagation de l'événement pour éviter de déclencher d'autres actions non désirées.
    
        try {
          const response = await fetch('/fav/remove-media-perso', {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ selectedProfileId, mediaId: filmId }),
          });
    
          if (response.ok) {
            // Mettez à jour la liste des favoris après avoir supprimé un film
            const updatedFavs = favs.filter((fav) => fav._id !== filmId);
            setFavs(updatedFavs);
          } else {
            console.error('Failed to remove media from the list');
          }
        } catch (error) {
          console.error('Error:', error);
        }
      };
    
      return (
        <div className={`liste favsList ${showMedias ? 'show' : ''}`}>
          {films.map((film, index) => {
            const isFilmInFavs = favs.some((fav) => fav._id === film._id);
    
            return (
              <div
                key={film._id}
                className={`carte ${showMedias ? 'fadeIn' : ''}`}
                href={`/video/${film._id}`}
                style={{
                  backgroundImage: `url(${film.url})`,
                  animationDelay: `${100 * index}ms`,
                }}
              >
                <h3>{film.nom}</h3>
                <div className="overlay">
                <a href={`/video/${film._id}`} className="play">
                  <img 
                    src="https://cdn0.iconfinder.com/data/icons/google-material-design-3-0/48/ic_play_circle_filled_white_48px-512.png"
                    alt=""
                  />
                  </a>
                  <a
                    onClick={(e) => (isFilmInFavs ? handleHeartClickRemove(e, film._id) : handleHeartClickAdd(e, film._id))}
                    className={`heart-link ${isFilmInFavs ? 'like' : ''}`}
                    data-media-id={film._id}
                  >
                    <svg
                      className={`heart ${isFilmInFavs ? 'like' : ''}`}
                      viewBox="0 0 32 29.6"
                    >
                      <path d="M23.6,0c-3.4,0-6.3,2.7-7.6,5.6C14.7,2.7,11.8,0,8.4,0C3.8,0,0,3.8,0,8.4c0,9.4,9.5,11.9,16,21.2 c6.1-9.3,16-12.1,16-21.2C32,3.8,28.2,0,23.6,0z" />
                    </svg>
                  </a>
                  <a className="info" href={`/infos/${film.nom}`}>i</a>
                </div>
                <h3>{film.nom}</h3>
              </div>
            );
          })}
        </div>
      );

      
}

export default FilmList;





